import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Grid, Popup, Input, Segment, Dropdown} from 'semantic-ui-react';
import DatePicker from "react-datepicker"
import moment from "moment";
import debounce from "lodash.debounce";

const regex = new RegExp('[A-Za-z0-9 _.,!$]*');

export class DateFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: this.props.filter || "",
            fromDate: this.props.fromDate || moment().subtract(12, "months").toDate(),
            toDate: this.props.toDate || moment().toDate(),
            filterValid: true,
            advancedFilters : this.props.advancedFilters
        };

        this.debouncedSubmit = debounce(this.props.onSubmitFilter, this.props.interval || 500);
    }

    componentDidUpdate()
    {
  
      if(this.state.filter === "" && this.props.filter !== "" && this.state.loadedSave === false)
      {
       
        this.setState({
          filter : this.props.filter,
          filterValid : true,
          loadedSave : true,
          advancedFilters : this.props.advancedFilters
        })
  
        this.debouncedSubmit({ filter: this.props.filter });
      } else
  
      {
        if(!this.state.advancedFilters && this.props.advancedFilters)
        {
        this.setState({
          advancedFilters : this.props.advancedFilters
        })
      }
      }
    }

    handleChangeDropDown = (_p, {name, value }) => {


        this.props.onAdvancedFilterChange({name, value })
    
      };

    handleOnChange = (event, {name, value}) => {
        if (value !== '' && !regex.test(value)) {
            this.setState({[name]: value, filterValid: false});
        } else {
            this.setState({[name]: value, filterValid: true}, this.raiseChange);
        }
    };

    fromDateChanged = (newDate) => {
        this.setState({ fromDate: newDate || null }, this.raiseChange); // Reset to null if cleared
    }

    toDateChanged = (newDate) => {
        this.setState({ toDate: newDate || null }, this.raiseChange); // Reset to null if cleared
    }

    raiseChange = () => {
        this.debouncedSubmit({filter: this.state.filter, fromDate: this.state.fromDate, toDate: this.state.toDate});
    }

    render() {
        const {filter} = this.state;
        let popupMessage = '';
        if (!this.state.filterValid) {
            popupMessage = 'Invalid character.';
        } else if (this.props.totalCount === 0) {
            popupMessage = 'No results found.';
        }

        const CustomInput = ({ value, onClick }) => (
            <Input fluidvalue={value} value={value} onClick={onClick} iconPosition='left'  icon="calendar"/>
        );

        return (
            <Grid padded stackable columns='equal'>
                <Grid.Row >
                    <Grid.Column width={8}>
                        <Popup
                            trigger={
                                <Fragment>
                                    <h4>Filter</h4>
                                    <Input
                                        fluid
                                        placeholder="Enter the filter."
                                        name="filter"
                                        value={filter}
                                        defaultValue={filter}
                                        error={!this.state.filterValid}
                                        onChange={this.handleOnChange}
                                        icon="search"
                                        disabled={this.props.disabled}
                                        ref={ref => ref && ref.focus()}
                                        onFocus={(e)=>e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                

                                    />
                                </Fragment>
                            }
                            content={popupMessage}
                            on="click"
                            open={!this.state.filterValid || this.props.totalCount === 0}
                            position="right center"
                        />
                    </Grid.Column>
                    <Grid.Column width={4}>
                    <h4>{this.props.fromDateLabel ? this.props.fromDateLabel : 'From Date'}</h4>
                        <DatePicker  selected={this.state.fromDate} locale="en-GB" isClearable dateFormat="dd/MM/yyyy" onChange={this.fromDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}/>
                    </Grid.Column>
                    <Grid.Column width={4}>
                    <h4>{this.props.toDateLabel ? this.props.toDateLabel : 'To Date'}</h4>

                        <DatePicker selected={this.state.toDate} locale="en-GB" isClearable dateFormat="dd/MM/yyyy" onChange={this.toDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}/>
                    </Grid.Column>
                </Grid.Row>
                {(this.state && this.state.advancedFilters && this.state.advancedFilters.length) > 0 &&
              

              
              <Grid.Row>
                <Grid.Column>
              <Segment.Group horizontal>
           
                    {this.state.advancedFilters.map((el, index) => 
                      <Segment key={index}>
                        <h4>
                        {el.filterName === 'HHDataType'
                            ? 'AMR/HH'
                            : el.filterName.replace(/([A-Z])/g, ' $1').trim()
                        }
                        </h4>
                      <Dropdown 
                      name={el.filterName} 
                      placeholder={el.filterName} 
                      multiple fluid selection 
                      options={el.filterValues}  onChange={this.handleChangeDropDown} />
                      
                      </Segment>
                      )}
                </Segment.Group>
                </Grid.Column>
            </Grid.Row>

            }
            </Grid>
        );
    }
}

DateFilter.propTypes = {
    onSubmitFilter: PropTypes.func.isRequired,
    onAdvancedFilterChange : PropTypes.func,
    interval: PropTypes.number,
    filter: PropTypes.string,
    disabled: PropTypes.bool,
    totalCount: PropTypes.number.isRequired
};
